import Vue from 'vue'
import Vuex from 'vuex'
import locale from './modules/locale'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		screen_width: document.documentElement.clientWidth,//屏幕宽度
	},
	getters: {
		isMobile(state) {
			return state.screen_width <= 1200 ? true:false
		},
		locale(state) {
			return state.locale.locale
		},
	},
	mutations: {
		changeScreenWidth(state,data) {
			var w = document.documentElement.clientWidth;
			var h = document.documentElement.clientHeight;
			localStorage.setItem('screen_width',w)
			state.screen_width = w
			
			let rootDom = document.querySelector('html');
			console.log("rootDom: ",rootDom);
			
			rootDom.style.fontSize = w <= 1200 ? w / 10 + 'px' : '16px';
			
			console.log("changeScreenWidth: ",w);
		},
	},
	actions: {
		
	},
	modules: {
		locale
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js